function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#20ad9b;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.125,15.75h-18A1.128,1.128,0,0,0,18,16.875V27H4.5V10.125A1.128,1.128,0,0,0,3.375,9H1.125A1.128,1.128,0,0,0,0,10.125v24.75A1.128,1.128,0,0,0,1.125,36h2.25A1.128,1.128,0,0,0,4.5,34.875V31.5h36v3.375A1.128,1.128,0,0,0,41.625,36h2.25A1.128,1.128,0,0,0,45,34.875V23.625A7.871,7.871,0,0,0,37.125,15.75Zm-27.562-9h8.866l1.941,3.881a1.123,1.123,0,0,0,2.011,0l3.495-6.989L27.429,6.75H36A1.125,1.125,0,0,0,36,4.5H28.821L26.88.619a1.123,1.123,0,0,0-2.011,0L21.375,7.608l-1.4-2.8A.565.565,0,0,0,19.47,4.5H9.563A.564.564,0,0,0,9,5.063V6.188A.564.564,0,0,0,9.563,6.75Zm1.688,18a4.5,4.5,0,1,0-4.5-4.5A4.5,4.5,0,0,0,11.25,24.75Z",
  transform: "translate(0 0.004)"
});

const SvgIconProcedimientos = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 36.004,
    viewBox: "0 0 45 36.004",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconProcedimientos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Procedimientos.c1487d47.svg";
export { ForwardRef as ReactComponent };